export default __webpack_public_path__ + "static/media/passenger_hero.fa84d23d.png";